import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { QuestionWrapper, AnswerWrapper } from 'Stories/components/Form/styles';
import { StyledSingleSelectQuestion } from './singleSelectStyles';

const SingleSelect = ({ name, onChange, text, filteredOptions }) => {
  return (
    <StyledSingleSelectQuestion>
      <QuestionWrapper id={`${name}-form-question`} className="FormQuestion-root">
        <Typography id={`${name}-question`} className="FormQuestion-question">
          {text}
        </Typography>
        <AnswerWrapper id={`${name}-answer-wrapper`} className="FormAnswer-root">
          <RadioGroup aria-labelledby={`${name}-question`} name={`${name}-options`} onChange={onChange}>
            {filteredOptions.map((option) => (
              <FormControlLabel
                key={option.name}
                value={option.name}
                control={<Radio name={option.name} disableRipple className="hidden-radio" />}
                label={option.text}
                className="button-like-label"
              />
            ))}
          </RadioGroup>
        </AnswerWrapper>
      </QuestionWrapper>
    </StyledSingleSelectQuestion>
  );
};

SingleSelect.propTypes = {
  name: PropTypes.string,
  text: PropTypes.string,
  options: PropTypes.array,
  filteredOptions: PropTypes.array,
  onChange: PropTypes.func,
};

export default SingleSelect;
